// extracted by mini-css-extract-plugin
export var orderDetails = "_ph-2";
export var orderImage = "_ph-1";
export var orderMeta = "_ph-3";
export var orderSummary = "_ph-0";
export var rightArrow = "_ph-4";